import { request } from '../api'
import { useServerFetch } from './useServerFetch'
import { useEnvApi } from './useEnvApi'

export type AppDownloadLinks = {
  appStoreUrl: string
  googlePlayUrl: string
  androidApkUrl: string
}

type AppDownloadLinksResponse = {
  code?: number
  message?: string
  succeed?: boolean
  data?: AppDownloadLinks
}

export const useDownApi = () => {
  const api = useEnvApi()

  const getAppDownloadLinks = async () => {
    const requestConfig = {
      baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
      url: '/api/v4/bit/web/down/app-link',
      method: 'GET',
    }

    const response = import.meta.server
      ? await useServerFetch<AppDownloadLinksResponse>(requestConfig)
      : await request<AppDownloadLinksResponse>(requestConfig)

    return response?.data ?? null
  }

  return {
    getAppDownloadLinks,
  }
}
